/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as Styles from '../../../../SharedModules/StyleConstant/StyleConstant';
import { textCustomComparator } from '../../../contactType/components/tableHead';

const tableHead = [
  {
    headerName: 'Price Type Code',
    field: 'priceTypeCd',
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_100,
    maxWidth: Styles.Width_180,
    cellStyle: {
      display: 'flex',
      alignItems: 'center',
      'border-right-color': Styles.BorderColor,
    },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
      textCustomComparator: textCustomComparator,
    },
  },
  {
    headerName: 'Short Description',
    field: 'shortDescr',
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_100,
    cellRenderer: 'textFieldComponent',
    cellRendererParams: {
      maxLength: 30,
    },
    cellStyle: {
      display: 'flex',
      alignItems: 'center',
      'border-right-color': Styles.BorderColor,
    },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
      textCustomComparator: textCustomComparator,
    },
  },
  {
    headerName: 'Long Description',
    field: 'longDescr',
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_200,
    cellRenderer: 'textFieldComponent',
    cellRendererParams: {
      maxLength: 255,
    },
    cellStyle: {
      display: 'flex',
      alignItems: 'center',
      'border-right-color': Styles.BorderColor,
    },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
      textCustomComparator: textCustomComparator,
    },
  },
  {
    headerName: 'Display Sequence',
    field: 'dispSeq',
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_200,
    maxWidth: Styles.Width_200,
    cellRenderer: 'textFieldComponent',
    sort: 'asc',
    cellRendererParams: {
      type: 'number',
      maxLength: 3,
      textAlign: 'right',
    },
    cellStyle: {
      display: 'flex',
      alignItems: 'center',
      'border-right-color': Styles.BorderColor,
    },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
      textCustomComparator: textCustomComparator,
    },
  },
  {
    headerName: 'Allow Entry',
    field: 'allowEntryInd',
    minWidth: Styles.Width_150,
    maxWidth: Styles.Width_150,
    showCheckboxIcon: true,
    cellStyle: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    filter: false,
    sortable: false,
    suppressMenu: false,
    resizable: false,
    cellRenderer: 'customCheckboxRenderer',
    pdfExportOptions: {
      skipColumn: true,
    },
  },
];

export const tableHeadPriceType = [
  {
    headerName: 'Price Type Code',
    field: 'priceTypeCd',
    sortable: true,
    sort: 'asc',
    suppressMenu: false,
    minWidth: Styles.Width_100,
    maxWidth: Styles.Width_180,
    cellStyle: {
      display: 'flex',
      alignItems: 'center',
      'border-right-color': Styles.BorderColor,
    },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
      textCustomComparator: textCustomComparator,
    },
  },
  {
    headerName: 'Short Description',
    field: 'shortDescr',
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_220,
    cellRenderer: 'textFieldComponent',
    cellRendererParams: {
      maxLength: 30,
    },
    cellStyle: {
      display: 'flex',
      alignItems: 'center',
      'border-right-color': Styles.BorderColor,
    },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
      textCustomComparator: textCustomComparator,
    },
  },
  {
    headerName: 'Long Description',
    field: 'longDescr',
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_220,
    cellRenderer: 'textFieldComponent',
    cellRendererParams: {
      maxLength: 255,
    },
    cellStyle: {
      display: 'flex',
      alignItems: 'center',
      'border-right-color': Styles.BorderColor,
    },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
      textCustomComparator: textCustomComparator,
    },
  },
  {
    headerName: 'Display Sequence',
    field: 'dispSeq',
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_200,
    maxWidth: Styles.Width_200,
    cellRenderer: 'textFieldComponent',
    cellRendererParams: {
      type: 'number',
      maxLength: 3,
      textAlign: 'right',
    },
    cellStyle: {
      display: 'flex',
      alignItems: 'center',
      'border-right-color': Styles.BorderColor,
    },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
      textCustomComparator: textCustomComparator,
    },
  },
  {
    headerName: 'Allow Entry',
    field: 'allowEntryInd',
    minWidth: Styles.Width_150,
    maxWidth: Styles.Width_150,
    showCheckboxIcon: true,
    cellStyle: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    filter: false,
    sortable: false,
    suppressMenu: false,
    resizable: false,
    cellRenderer: 'customCheckboxRenderer',
    pdfExportOptions: {
      skipColumn: true,
    },
  },
];

export default tableHead;
